/* eslint-disable no-undef */
export default {
	name: "link-products-to-combo-discount-group-modal",
	props: ["heading", "modalId", "showModal", "comboDiscountGroupId", "currentLinkedProducts"],
	emits: ["closeClicked", "saveButtonClicked"],
	data() {
		return {
			comboDiscountGroupProducts: [],
			products: [],
			comboDiscountGroup: {},
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false,
			productSearchQuery: null,
			productsToLink: [],
			productsToUnlink: [],
			hasSearched: false,
			originalLinkedProducts: [] // Track original state when modal opens
		};
	},
	methods: {
		getProducts() {
			this.loading = true;
			let request = {
				allowCollection: true,
				isActive: true
			};
			productService.getProducts(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.products = successResponse.data.result;
						this.products = dataTableHelper.castFieldValues(this.products);
						this.getComboDiscountGroupProducts();
					}
					//this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		getComboDiscountGroupProducts() {
			this.loading = true;
			orderService.getProductsForComboDiscountGroup(this.comboDiscountGroupId, this.productSearchQuery).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.comboDiscountGroupProducts = successResponse.data.result;
						
						// Update selection state based on current linked products from parent
						for(let i = 0; i < this.comboDiscountGroupProducts.length; i++) {
							const currentLinkedProduct = this.currentLinkedProducts ? 
								this.currentLinkedProducts.find(p => p.productId === this.comboDiscountGroupProducts[i].productId) : null;
							
							if (currentLinkedProduct) {
								this.comboDiscountGroupProducts[i].isSelected = true;
								this.comboDiscountGroupProducts[i].applyDiscount = currentLinkedProduct.applyDiscount;
								this.productsToLink.push({
									productId: this.comboDiscountGroupProducts[i].productId,
									applyDiscount: this.comboDiscountGroupProducts[i].applyDiscount
								});
							} else {
								this.comboDiscountGroupProducts[i].isSelected = false;
								this.comboDiscountGroupProducts[i].applyDiscount = false;
								this.productsToLink = this.productsToLink.filter(x => x.productId !== this.comboDiscountGroupProducts[i].productId);
							}
							
							// Override with pending changes if any
							if(this.hasSearched || this.productsToLink.length > 0){
								this.comboDiscountGroupProducts[i].isSelected = this.productsToLink.find(x => x.productId === this.comboDiscountGroupProducts[i].productId) !== undefined;
							}
						}
						this.onModalSaveClick(false);
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onProductSelectOrUnselect(product) {
			// Find if the product was originally linked
			const wasOriginallyLinked = this.originalLinkedProducts.find(p => p.productId === product.productId) !== undefined;
			
			if(product.isSelected) {
				// Product is now selected
				if (!wasOriginallyLinked) {
					// This is a new link
					if(!this.productsToLink.find(x => x.productId === product.productId)) {
						this.productsToLink.push({
							productId: product.productId,
							applyDiscount: product.applyDiscount || false
						});
					}
				}
				// If it was originally linked and is now selected again, remove it from unlink list
				this.productsToUnlink = this.productsToUnlink.filter(x => x.productId !== product.productId);
			} else {
				// Product is now unselected
				product.applyDiscount = false;
				if (wasOriginallyLinked) {
					// This is an unlink of an originally linked product
					if(!this.productsToUnlink.find(x => x.productId === product.productId)) {
						this.productsToUnlink.push({
							productId: product.productId,
							applyDiscount: false
						});
					}
				}
				// If it was not originally linked and is now unselected, remove it from link list
				this.productsToLink = this.productsToLink.filter(x => x.productId !== product.productId);
			}
		},
		onApplyDiscountChanged(product) {
			// Find if the product was originally linked
			const wasOriginallyLinked = this.originalLinkedProducts.find(p => p.productId === product.productId) !== undefined;
			
			// Update in productsToLink if it's a new product or if it's changing state
			let productInLinkList = this.productsToLink.find(x => x.productId === product.productId);
			if(productInLinkList) {
				productInLinkList.applyDiscount = product.applyDiscount;
			} else if (wasOriginallyLinked && product.isSelected) {
				// This is an originally linked product that's changing applyDiscount value
				// Need to check if the value is different from original
				const originalProduct = this.originalLinkedProducts.find(p => p.productId === product.productId);
				if (originalProduct && originalProduct.applyDiscount !== product.applyDiscount) {
					// Add to link list to update the applyDiscount value
					this.productsToLink.push({
						productId: product.productId,
						applyDiscount: product.applyDiscount
					});
					// Remove from unlink list if it exists
					this.productsToUnlink = this.productsToUnlink.filter(x => x.productId !== product.productId);
				}
			}
		},
		onFilterSearchClick() {
			this.hasSearched = true;
			this.getComboDiscountGroupProducts();
		},
		onModalSaveClick(shouldShowMessage) {
			console.log("productsToLink.length", this.productsToLink.length);
			if(this.productsToLink.length === 0 && this.productsToUnlink.length === 0 && shouldShowMessage) {
				return;
			}
			
			if(shouldShowMessage) {
				this.loading = true;
				let request = {
					comboDiscountGroupId: this.comboDiscountGroupId,
					productsToLink: this.productsToLink.map(product => ({
						productId: product.productId,
						applyDiscount: product.applyDiscount
					})),
					productsToUnlink: this.productsToUnlink.map(product => ({
						productId: product.productId,
						applyDiscount: product.applyDiscount
					}))
				};

				this.$emit('saveButtonClicked', request);
				
				// orderService.linkAndUnlinkProductsFromComboDiscountGroup(request).then(
				// 	successResponse => {
				// 		let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
				// 		if(isSuccess){
				// 			this.showSuccessMessage = true;
				// 			this.successMessage = "Products have been successfully linked/unlinked to the combo discount group.";
				// 			this.productsToLink = [];
				// 			this.productsToUnlink = [];
				// 		}
				// 		this.loading = false;
				// 	},
				// 	errorResponse => {
				// 		console.log("error", errorResponse);
				// 		this.loading = false;
				// 		apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				// 	}
				// );
			}
		},
		onModalCloseClick() {
			this.clearMessageAlerts();
			this.$emit('closeClicked');
		},
		clearMessageAlerts() {
			let wasSuccess = this.showSuccessMessage;
			this.showSuccessMessage = false;
			this.showErrorMessage = false;
			this.successMessage = null;
			this.errorMessage = null;
			
			// Reset the products arrays when closing after success
			if(wasSuccess) {
				// Pass the products data to parent component
				const productsData = {
					productsToLink: [...this.productsToLink],
					productsToUnlink: [...this.productsToUnlink]
				};
				
				this.productsToLink = [];
				this.productsToUnlink = [];
				this.hasSearched = false;
				this.$emit('saveButtonClicked', productsData);
			}
		}
	},
	watch: {
		heading: {
			handler: function () {
				if(this.heading){
					this.modalHeading = this.heading;
				}
			},
			immediate: true,
			deep: true
		},
		modalId:{
			handler: function () {
				if(this.modalId){
					this.modalComponentId = this.modalId;
				}
			},
			immediate: true,
			deep: true
		},
		showModal:{
			handler: function (){
				console.log("showModal", this.showModal);
				if(this.showModal){
					// Reset modal state when opening
					this.showSuccessMessage = false;
					this.showErrorMessage = false;
					this.successMessage = null;
					this.errorMessage = null;
					this.productsToLink = [];
					this.productsToUnlink = [];
					this.hasSearched = false;
					this.productSearchQuery = null;
					
					// Store original linked products state
					this.originalLinkedProducts = this.currentLinkedProducts ? [...this.currentLinkedProducts] : [];
					
					this.getProducts();
					$("#" + this.modalId).modal("show");
				}
				else {
					$("#" + this.modalId).modal("hide");
				}
			},
			immediate: true,
			deep: true
		}
		// showModal(newVal) {
		// 	if(newVal) {
		// 		this.modalHeading = this.heading;
		// 		this.modalComponentId = this.modalId;
		// 		this.getProducts();
		// 		$("#" + this.modalComponentId).modal("show");
		// 	} else {
		// 		$("#" + this.modalComponentId).modal("hide");
		// 	}
		// }
	}
};